import React, { useRef } from 'react';
import { Search } from 'lucide-react';

const BuscadorInput = ({ searchTerm, setSearchTerm, className, placeholder = "Buscar..." }) => {
    const inputRef = useRef(null);

    return (
        <div
            className={`relative w-32 focus-within:w-44 sm:w-36 sm:focus-within:w-52 lg:w-48 lg:focus-within:w-72 transition-all duration-200 ${className ?? ''}`}
            onClick={() => inputRef.current?.focus()}
        >
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-base-content/40 pointer-events-none">
                <Search size={14} />
            </span>
            <input
                ref={inputRef}
                type="text"
                value={searchTerm}
                placeholder={placeholder}
                className="input input-bordered w-full pl-8 text-sm"
                onChange={(e) => setSearchTerm(e.target.value)}
            />
        </div>
    );
};

export default BuscadorInput;
